import Box from "@mui/material/Box"
import Checkbox from "@mui/material/Checkbox"
import FormControl from "@mui/material/FormControl"
import FormControlLabel from "@mui/material/FormControlLabel"
import FormGroup from "@mui/material/FormGroup"
import FormLabel from "@mui/material/FormLabel"
import { makeStyles } from "tss-react/mui-compat"

const useStyles = makeStyles()({
  root: {
    display: "flex",
    flexDirection: "column",
  },
  formControl: {
    display: "flex",
  },
})

interface ICheckboxGroup {
  checked: boolean[]
  label: string
  onChange: (values: boolean[]) => void
  options: any[]
}

const CheckboxGroup = (props: ICheckboxGroup) => {
  const { checked, label, onChange, options } = props

  const { classes } = useStyles()

  return (
    <Box className={classes.root}>
      <FormControl component="fieldset" className={classes.formControl}>
        <FormLabel component="legend">{label}</FormLabel>
        <FormGroup>
          {options.map((option, i) => (
            <FormControlLabel
              key={`${label}-checkbox-${i}`}
              control={
                <Checkbox
                  color="primary"
                  checked={checked[i]}
                  onChange={(event) => {
                    const newChecked = [...checked]
                    newChecked[i] = event.target.checked
                    onChange(newChecked)
                  }}
                  name={option.value}
                />
              }
              label={option.label}
            />
          ))}
        </FormGroup>
      </FormControl>
    </Box>
  )
}

export default CheckboxGroup
